import React, { FC, useEffect,useState } from "react";
import ChatWindow from "../organisms/ChatWindow";
import SectionHeader from "../molecules/SectionHeader";
import MainLayout from "../../Layouts/MainLayout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useChatContext } from "../../../context/ChatContext";
import HistorySidebar from "../organisms/HistorySidebar";

const ChatLayout: FC = () => {
  const { id } = useParams();
  
  const location = useLocation();
  const sidebarType = location.pathname.includes("ai_space") ? "history" : "dashboard";
  const spaceChat = location.pathname.includes("section");
  const { crewName, spaceName } = location.state || { spaceName: "", crewName: "" };
  const { fetchChatHistory } = useChatContext();
  const [toggle, setToggle] = useState<boolean>(true);

 
  useEffect(() => {
    if (id) fetchChatHistory(id,spaceChat);
  }, [id, fetchChatHistory]);

  const navigate = useNavigate()
const handleTrain = ()=>{
  if(spaceChat){
    navigate(`/training-space/${id}/upload`)
  }
  else {
    navigate(`/training/${id}/upload`)
  }
}

  return (
    <MainLayout excludeSidebar={true}>

      <div className="row  h-100 overflow-auto">
        {toggle && <div className="col-2 pe-0 h-100 overflow-auto">
          
          <HistorySidebar Id={id} spaceChat = {spaceChat} toggle={toggle} setToggle={setToggle} /> 
        </div>}
        <div className={`${toggle ? "col-10 px-0" : "col-12 px-0"} h-100 d-flex flex-column overflow-auto`}>
        <SectionHeader
            title={
              spaceChat
                ? `Access knowledge hub (Using Claude LLM)`
                : `Crew AI space`
            }
            action="Build knowledge"
            train = {true}
            onAdd={handleTrain}
          />
          
          <ChatWindow  spaceChat = { spaceChat} Id={id || ""}  toggle={toggle} setToggle={setToggle} />
        </div>
      </div>
    </MainLayout>
  );
};

export default ChatLayout;
